import { render, staticRenderFns } from "./FormGroup.vue?vue&type=template&id=48e50218&scoped=true&"
import script from "./FormGroup.vue?vue&type=script&lang=js&"
export * from "./FormGroup.vue?vue&type=script&lang=js&"
import style0 from "./FormGroup.vue?vue&type=style&index=0&id=48e50218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e50218",
  null
  
)

export default component.exports